<template>
  <div class="form-row-input" :ref="dateType">
    <ejs-datepicker
      id="date"
      float-label-type="Always"
      type="date"
      :placeholder="placeHolder"
      v-model="permit[dateType]"
      @change="onDateChange"
      :showErrorLabel="showErrorLabel"
      :errorLabelMessage="errorLabelMessage"
      :maxlength="10"
      :readOnly="readOnly"
      :showClearButton="!readOnly"
      :class="dateClass"
    />
    <label class="e-error" v-if="showErrorLabel">{{ errorLabelMessage }}</label>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { dateRule, requiredRule, dateRuleRegEx } from '@/shared/constants';
// import sccInputValidator from '@/components/base/scc-input-validator.vue';

export default {
  // components: { sccInputValidator },
  props: {
    placeHolder: String,
    dateType: String,
  },
  data() {
    return {
      rules: [requiredRule, dateRule],
      showErrorLabel: false,
      errorLabelMessage: null,
    };
  },
  computed: {
    ...mapGetters({
      permit: 'permit',
    }),
    readOnly() {
      return (
        this.dateType === 'applicationDate' || this.dateType === 'requestDate'
      );
    },
    // eslint-disable-next-line vue/return-in-computed-property
    dateClass() {
      // eslint-disable-next-line no-unused-expressions
      this.dateType === 'applicationDate' || this.dateType === 'requestDate'
        ? 'readOnlyField'
        : '';
    },
  },
  methods: {
    onDateChange(e) {
      const val = e.value;
      if (val) {
        if (dateRuleRegEx.test(new Date(val).toLocaleDateString())) {
          this.$refs[this.dateType].classList.remove('e-error');
          // eslint-disable-next-line no-unused-expressions
          (this.showErrorLabel = false);
          (this.errorLabelMessage = null);
        }
      }
    },
  },
};
</script>
